import { Col, Container, Row, Stack } from "react-bootstrap";
import { renderSortIcon } from "../helperRenders";

export default function HybridHitlistHeader({ sortConfig, requestSort, airplayMix }) {
    return (
        <Container fluid>
            <Row className="bg-ra-dark-blue text-white fw-bold py-1 rounded-2 fs-8-xs table-header user-select-none h-100">
                <Col xs xl={1} onClick={requestSort ? () => requestSort("rank") : null} className=" align-self-center">
                    <Stack direction="horizontal" className="justify-content-xl-center">
                        <span className="offset-1">Rank</span>
                        <span className="col-1">{renderSortIcon("rank", sortConfig)}</span>
                    </Stack>
                </Col>
                <Col xs xl onClick={requestSort ? () => requestSort("song.artist") : null} className=" align-self-center">
                    <Stack direction="horizontal">
                        <span>Artist</span>
                        <span className="col-1">{renderSortIcon("song.artist", sortConfig)}</span>
                    </Stack>
                </Col>
                <Col xs xl onClick={requestSort ? () => requestSort("song.title") : null} className=" align-self-center">
                    <Stack direction="horizontal">
                        <span>Title</span>
                        <span className="col-1">{renderSortIcon("song.title", sortConfig)}</span>
                    </Stack>
                </Col>
                <Col xs xl={2} onClick={requestSort ? () => requestSort("song.release_year") : null} className=" align-self-center">
                    <Stack direction="horizontal" className="justify-content-center">
                        <span className="offset-1 text-center">Release Year</span>
                        <span className="col-1">{renderSortIcon("song.release_year", sortConfig)}</span>
                    </Stack>
                </Col>
                {airplayMix && (
                    <>
                        <Col xs xl={1} onClick={requestSort ? () => requestSort("digital_rank") : null} className=" align-self-center">
                            <Stack direction="horizontal" className="justify-content-center">
                                <span className="offset-1 text-center">Digital Rank</span>
                                <span className="col-1">{renderSortIcon("digital_rank", sortConfig)}</span>
                            </Stack>
                        </Col>
                        <Col xs xl={1} onClick={requestSort ? () => requestSort("airplay_rank") : null} className=" align-self-center">
                            <Stack direction="horizontal" className="justify-content-center">
                                <span className="offset-1 text-center">Airplay Rank</span>
                                <span className="col-1">{renderSortIcon("airplay_rank", sortConfig)}</span>
                            </Stack>
                        </Col>
                    </>
                )}
                <Col xs xl={1} onClick={requestSort ? () => requestSort("previous_rank") : null} className=" align-self-center">
                    <Stack direction="horizontal" className="justify-content-center">
                        <span className="offset-1 text-center">Trend</span>
                        <span className="col-1">{renderSortIcon("previous_rank", sortConfig)}</span>
                    </Stack>
                </Col>
            </Row>
        </Container>
    );
}
